var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBirdscoreFeatureCsv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 238,
    viewBox: "0 0 300 238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 238,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 223.987,
    height: 88.442,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2,224.025a2.2,2.2,0,0,1-2.2-2.2V72.239A9.241,9.241,0,0,1,37.223,63H269.115a9.241,9.241,0,0,1,9.223,9.239V221.825a2.2,2.2,0,0,1-2.2,2.2Z",
    transform: "translate(-2.933 -8.023)",
    fill: "#a9baea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.811,64.9a7.034,7.034,0,0,1,7.027,7.039V221.525H29.892V71.939A7.034,7.034,0,0,1,36.919,64.9Zm0-4.4H36.919A11.442,11.442,0,0,0,25.5,71.939V221.525a4.4,4.4,0,0,0,4.392,4.4H275.838a4.4,4.4,0,0,0,4.392-4.4V71.939A11.442,11.442,0,0,0,268.811,60.5",
    transform: "translate(-2.629 -7.723)",
    fill: "#7a76b7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 228.379,
    height: 136.387,
    rx: 4.5,
    transform: "translate(36.047 67.296)",
    fill: "#caeaff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.622,78.9a1.758,1.758,0,0,1,1.757,1.76V209.128a1.758,1.758,0,0,1-1.757,1.76H44.149a1.758,1.758,0,0,1-1.757-1.76V80.659a1.758,1.758,0,0,1,1.757-1.76Zm0-4.4H44.149A6.161,6.161,0,0,0,38,80.659V209.128a6.161,6.161,0,0,0,6.149,6.159H264.622a6.161,6.161,0,0,0,6.149-6.159V80.659a6.161,6.161,0,0,0-6.149-6.159",
    transform: "translate(-4.149 -9.404)",
    fill: "#7a76b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.48,265.5a11,11,0,0,1-10.98-11v-8.8a2.2,2.2,0,0,1,2.2-2.2H295.44a2.2,2.2,0,0,1,2.2,2.2v8.8a11,11,0,0,1-10.98,11Z",
    transform: "translate(0.168 -29.698)",
    fill: "#eff7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.136,245.4v8.8a8.791,8.791,0,0,1-8.784,8.8H13.176a8.791,8.791,0,0,1-8.784-8.8v-8.8Zm0-4.4H4.392A4.4,4.4,0,0,0,0,245.4v8.8a13.2,13.2,0,0,0,13.176,13.2H286.352a13.2,13.2,0,0,0,13.176-13.2v-8.8a4.4,4.4,0,0,0-4.392-4.4",
    transform: "translate(0.472 -29.398)",
    fill: "#7a76b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.96,264.8H13.784A8.791,8.791,0,0,1,5,256H295.744a8.791,8.791,0,0,1-8.784,8.8",
    transform: "translate(-0.136 -31.199)",
    fill: "#cce2f2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.243 69.496)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43,100.751V81.26a1.758,1.758,0,0,1,1.757-1.76H265.23a1.758,1.758,0,0,1,1.757,1.76v86.672C266.987,168.9,43,100.751,43,100.751",
    transform: "translate(-43 -79.5)",
    fill: "#eff7ff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M195.068,37.7V2.5H88.784A8.791,8.791,0,0,0,80,11.3V204H238.987V46.5H203.852a8.791,8.791,0,0,1-8.784-8.8",
    transform: "translate(-9.257 -0.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.068,37.7V2.5H88.784A8.791,8.791,0,0,0,80,11.3V204H238.987V46.5H203.852A8.791,8.791,0,0,1,195.068,37.7Z",
    transform: "translate(-9.257 -0.758)",
    fill: "none",
    stroke: "#7a76b7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x2: 43.919,
    y2: 43.996,
    transform: "translate(185.811 1.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    x2: 43.919,
    y2: 43.996,
    transform: "translate(185.811 1.742)",
    fill: "none",
    stroke: "#7a76b7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,37.7a8.791,8.791,0,0,0,8.784,8.8h35.135L211,2.5Z",
    transform: "translate(-25.189 -0.758)",
    fill: "#7a76b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.789,59.135q-.154.82-.309,1.918t-.293,2.4h-.726a25.151,25.151,0,0,1-6.848-.851,13.816,13.816,0,0,1-5.1-2.585,9.45,9.45,0,0,1-2.532-3.118,9.057,9.057,0,0,1-.9-4.11,8.481,8.481,0,0,1,.888-3.909,9.532,9.532,0,0,1,2.494-3.057,13.949,13.949,0,0,1,5.157-2.654,23.271,23.271,0,0,1,6.577-.906h.741q.078.665.209,1.849t.347,2.482h-.711a21.214,21.214,0,0,0-3.165.287,13.419,13.419,0,0,0-3.227.875,7.69,7.69,0,0,0-2.942,2.1,4.513,4.513,0,0,0-1.072,2.965A4.645,4.645,0,0,0,144.4,55.79a7.332,7.332,0,0,0,2.934,2.107,11.987,11.987,0,0,0,3.311.952,21.927,21.927,0,0,0,3.219.287h.927Z",
    transform: "translate(-16.321 -5.533)",
    fill: "#7a76b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.354,57.1a4.873,4.873,0,0,1-.888,2.931,6.849,6.849,0,0,1-2.416,2.034,11.132,11.132,0,0,1-3.311,1.051,23.284,23.284,0,0,1-3.976.341q-1.451,0-2.6-.055t-1.52-.085l-.463-4.16q.184.03,1.412.1t2.2.07a16.534,16.534,0,0,0,1.807-.123,10.725,10.725,0,0,0,1.806-.341,2.885,2.885,0,0,0,1.367-.751,1.653,1.653,0,0,0,.394-1.121,1.842,1.842,0,0,0-.432-1.245,5.018,5.018,0,0,0-1.483-1.044q-.648-.325-1.752-.819a15.486,15.486,0,0,1-1.891-.99,5.966,5.966,0,0,1-2.17-2.057,5.009,5.009,0,0,1-.656-2.537,4.642,4.642,0,0,1,.487-2.143,5.248,5.248,0,0,1,1.289-1.631,8.2,8.2,0,0,1,3.319-1.717,18.066,18.066,0,0,1,4.957-.6q1.358,0,2.339.039t1.227.07l.525,4.161q-.386-.016-1.22-.085t-2.084-.07a10.769,10.769,0,0,0-1.66.124,8.888,8.888,0,0,0-1.52.371,2.4,2.4,0,0,0-1.073.649,1.506,1.506,0,0,0-.394,1.052,1.623,1.623,0,0,0,.432,1.075,5.327,5.327,0,0,0,1.513,1.075q.71.355,1.66.788t1.86.959a6.27,6.27,0,0,1,2.192,2.026,4.905,4.905,0,0,1,.726,2.66",
    transform: "translate(-18.887 -5.526)",
    fill: "#7a76b7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.888,43.582q-.278.665-3.242,7.474t-5.327,12.239h-5.064q-2.47-5.724-4.763-10.963t-3.683-8.688L182.866,42q.2.649,2.22,5.762T188.91,57.2h.108q1.895-4.651,3.914-9.681T195.12,42Z",
    transform: "translate(-21.153 -5.501)",
    fill: "#7a76b7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 131.757,
    height: 17.598,
    transform: "translate(84.358 80.495)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 131.757,
    height: 17.598,
    transform: "translate(84.358 109.532)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 131.757,
    height: 17.598,
    transform: "translate(84.358 138.569)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 131.757,
    height: 17.598,
    transform: "translate(84.358 167.607)",
    fill: "#f1f1f1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBirdscoreFeatureCsv);
export default __webpack_public_path__ + "static/media/birdscore_feature_csv.32519c1f7197f53e6c762e196879f60e.svg";
export { ForwardRef as ReactComponent };